<div [id]="modalable.getModalId()" class="modal signable-quick-qink" data-backdrop="static"
     data-keyboard="false" role="dialog" tabindex="-1">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <ng-container>
                    <p class="text-center">
                        <img [attr.src]="assetService.getUrl('sidebar-quicklinks/edusuite-logo.png')" width="200" height="auto" alt="Lemberger Adaptive Mathematik Logo"/>
                    </p>
                    @if (modalable && modalable.formData) {
                        <p class="text-center">
                            <app-quicklink-sign-form [formData]="modalable.formData" buttonText="Öffnen"></app-quicklink-sign-form>
                        </p>
                    }
                    @if (!modalable || (!modalable.formData && !modalable.status)) {
                        <p>Lade Daten...</p>
                    }
                    @if (modalable && modalable.status === eResponseStatus.ERROR) {
                        <p>Es ist ein Fehler aufgetreten. Bitte versuche es später erneut.</p>
                    }
                    @if (modalable && modalable.status === eResponseStatus.NOT_ACCESSIBLE) {
                        @if (!applicationStateService.userData.loggedIn) {
                            <p class="mt-3">Für diese Aktion wird ein Benutzerkonto benötigt.</p>
                        } @else {
                            <p class="mt-3">
                                @if (!modalable.trialUrl && !modalable.storeUrl) {
                                    Im Moment ist Lemberger Adaptive Mathematik nicht verfügbar
                                } @else {
                                    Alle Inhalte von Lemberger Adaptive Mathematik nutzen
                                }
                            </p>

                            <p>
                                @if (modalable.storeUrl) {
                                    <a [href]="modalable.storeUrl" target="_blank" class="btn btn-buy-store">
                                        <img [attr.src]="'/sidebar-quicklinks/store-at-logo.png' |asset" alt="Icon der Shopping-Seite"/>
                                        Lemberger Adaptive Mathematik auf Store.at kaufen
                                    </a>
                                }
                                @if (modalable.trialUrl) {
                                    <a [href]="modalable.trialUrl" class="btn btn-main rounded-3">
                                        Lemberger Adaptive Mathematik kostenlos testen
                                    </a>
                                }
                            </p>
                        }
                    }
                </ng-container>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Zurück zum Buch</button>
            </div>
        </div>
    </div>
</div>
